import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import api from '../components/api';


const FiqueInformado = (props) => {

    
    const history = useHistory()

    var fiqueInformado_id = props.match.params.fiqueInformado_id

    var [dataHora, setDataHora] = useState()
    var [nome, setNome] = useState()
    var [organizacao, setOrganizacao] = useState()
    var [email, setEmail] = useState()
    var [telefone, setTelefone] = useState()
    var [municipio, setMunicipio] = useState()
    var [uf, setUf] = useState()
    var [autorizoComunicacoes, setAutorizoComunicacoes] = useState()
    var [autorizoDados, setAutorizoDados] = useState()


    async function carrega() {

        await api.get(`fiqueInformado/${fiqueInformado_id}`).then((result) => {

            //console.log(result.data)
            var data = result.data[0]

            setDataHora(data.dataHora)
            setNome(data.nome)
            setOrganizacao(data.organizacao)
            setEmail(data.email)
            setMunicipio(data.municipio)
            setUf(data.uf)
            setTelefone(data.telefone)

            setAutorizoComunicacoes(data.autorizoComunicacoes)
            setAutorizoDados(data.autorizoDados)

        }).catch((err) => {

            console.log(err.response)

        })

    }


    function apagar() {

        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'red',
		    title: 'Confirmação',
		    content: 'Confirma apagar este registro?',
		    buttons: {
		        Sim: function () {


                    api.delete(`fiqueInformado/${fiqueInformado_id}`).then((response) => {

                        //console.log(response.data)
                        if (response.data.alerta == 'ok') {

                            window.toastr.success('Apagado com sucesso!')
                            history.push('/FiqueInformado')

                        }
                        

                    }).catch((err) => {
                        console.log(err.response)
                    })
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }


    useEffect(() => {

        carrega()

    }, [])


    return (

        <div>

            <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-pin'></i>
                </div>
                <div class='header-title'>
                    <h1>Comunicação</h1>
                    <small>Fique Informado</small>
                    
                </div>
            </div>


            <div className="row">

                <div class="col-md-3">
                    <div class="form-group">
                        <label>Data/Hora</label>
                        <input type="text" class="form-control" placeholder="" value={dataHora} readOnly />
                                        
                    </div>
                </div>
                <div class="col-md-9">
                    <div class="form-group">
                        <label>Nome</label>
                        <input type="text" class="form-control" placeholder="" value={nome} readOnly />
                                        
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="form-group">
                        <label>Organização</label>
                        <input type="text" class="form-control" placeholder="" value={organizacao} readOnly />
                                        
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>E-mail</label>
                        <input type="text" class="form-control" placeholder="" value={email} readOnly />
                                        
                    </div>
                </div>

                <div class="col-md-3">
                    <div class="form-group">
                        <label>DDD + Telefone</label>
                        <input type="text" class="form-control" placeholder="" value={telefone} readOnly />
                                        
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>Município</label>
                        <input type="text" class="form-control" placeholder="" value={municipio} readOnly />
                                        
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>UF</label>
                        <input type="text" class="form-control" placeholder="" value={uf} readOnly />
                                        
                    </div>
                </div>

                <div class="col-md-12">
                    <div class="form-group">
                        <label>Desejo receber comunicações sobre as atividades do PHS</label>
                        <input type="text" class="form-control" placeholder="" style={{ backgroundColor: autorizoComunicacoes == true ? '#bfe3c8' : !autorizoComunicacoes ? '#e3bfc0' : ''}} value={autorizoComunicacoes == true ? 'Sim' : !autorizoComunicacoes ? 'Não' : ''} readOnly />
                                        
                    </div>
                </div>

                <div class="col-md-12">
                    <div class="form-group">
                        <label>Autorizo o armazenamento e a utilização dos dados fornecidos para divulgação de eventos, publicações e notícias por parte do PHS</label>
                        <input type="text" class="form-control" placeholder="" style={{ backgroundColor: autorizoDados == true ? '#bfe3c8' : !autorizoDados ? '#e3bfc0' : ''}} value={autorizoDados == true ? 'Sim' : !autorizoDados ? 'Não' : ''} readOnly />
                                        
                    </div>
                </div>



                <div class="col-md-12">

                    <br/>
                                    

                    <button type="button" class="btn btn-danger" onClick={() => apagar()} >Apagar</button>&nbsp;
                    <button type="button" class="btn btn-info" onClick={() => history.push('/FiqueInformado')}>Voltar</button>&nbsp;

                </div>


            </div>






        </div>


     )


}

export default FiqueInformado